"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CJFormLayoutGrid = exports.CJFormFullWidthContainer = exports.CJFormSubheading = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var CJFormContext_1 = require("./CJFormContext");
var Stack_1 = require("../../components/Stack");
var classnames_1 = __importDefault(require("classnames"));
var Grid_1 = require("../../components/Grid");
var CJFormSubheading = function (_a) {
  var heading = _a.heading,
    children = _a.children,
    description = _a.description,
    className = _a.className,
    restProps = __rest(_a, ["heading", "children", "description", "className"]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "medium",
    className: (0, classnames_1.default)("vsx-cjform-subheading", "vsx-cjform-fullwidth", className),
    paddingBottom: "medium"
  }, restProps, {
    children: [heading && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-cjform-subheading-heading"
    }, {
      children: heading
    })), (description || children) && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "vsx-cjform-subheading-description"
    }, {
      children: [(0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
        children: description
      }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
        children: children
      })]
    }))]
  }));
};
exports.CJFormSubheading = CJFormSubheading;
var CJFormFullWidthContainer = function (_a) {
  var className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["className", "children"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-cjform-fullwidth", className)
  }, restProps, {
    children: children
  }));
};
exports.CJFormFullWidthContainer = CJFormFullWidthContainer;
var CJFormLayoutGrid = function (_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    columns = _a.columns,
    restProps = __rest(_a, ["children", "className", "columns"]);
  var _c = (0, react_1.useContext)(CJFormContext_1.CJFormContext).width,
    width = _c === void 0 ? "narrow" : _c;
  var w = (_b = getWidth(columns)) !== null && _b !== void 0 ? _b : width;
  return (0, jsx_runtime_1.jsx)(Grid_1.Grid, __assign({
    className: (0, classnames_1.default)("vsx-cjform-grid", "vsx-cjform-fullwidth", className),
    columns: w === "narrow" ? "1fr" : "repeat(2, minmax(0, 1fr))"
  }, restProps, {
    children: children
  }));
};
exports.CJFormLayoutGrid = CJFormLayoutGrid;
var getWidth = function (columns) {
  if (columns === 1) return "narrow";
  if (columns === 2) return "wide";
  return undefined;
};